import React from 'react';

import { Loader } from '../../atoms';

function BundleLoader() {
  return (
    <div className='min-height-50vh w-100'>
      <Loader />
    </div>
  );
}

export default BundleLoader;
